export default __webpack_public_path__ + "static/media/infoSVGGray.17d44d36.svg";